import { isArray } from 'util';
import { mapCollection, sortByNumber } from '../../utils/collection.utils';
import { ToolManagamentRebuildOption } from '../tool-managament-rebuild-option';
import { parseNumber } from '../../utils/number.utils';

export class ToolManagamentRebuildOptionBuilder {
  static fromJson(json) {
    return (json)
      ? new ToolManagamentRebuildOption(
        json.hash,
        json.name,
        parseNumber(json.stockNumber),
        parseNumber(json.order)
      )
      : null;
  }

  static fromList(list) {
    return isArray(list) ?
      sortByNumber('order', mapCollection(ToolManagamentRebuildOptionBuilder.fromJson, list)) : [];
  }

}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/tool-managament-rebuild-option.builder.ts